import React from 'react';
import { JournalistModel, journalistModelInitial } from '../../Models/JournalistModel';

export interface IJournalistContextProps {
    journalist: JournalistModel,
    setJournalist: (journalist: JournalistModel) => void,
    journalistList: JournalistModel[],
    setJournalistList: (journalists: JournalistModel[]) => void,
}

export const journalistContextInitial: IJournalistContextProps = {
    journalist: journalistModelInitial,
    setJournalist: () => { ''; },
    journalistList: [journalistModelInitial],
    setJournalistList: () => { ''; },
};

export const JournalistContext = React.createContext(journalistContextInitial);